const getStorage = (storageType = "localStorage") => {
  if (typeof window === "undefined") {
    throw new Error("Window is not available");
  }

  const storage = window[storageType];

  if (!storage) {
    throw new Error(`${storageType} is not available`);
  }

  return storage;
};

const set = (key, value) => {
  try {
    const serializedValue = JSON.stringify(value);
    getStorage().setItem(key, serializedValue);
  } catch (error) {
    console.error(`Error setting item ${key} in localStorage`, error);
  }
};

const get = (key) => {
  try {
    const serializedValue = getStorage().getItem(key);
    if (serializedValue === null) {
      return undefined;
    }
    return JSON.parse(serializedValue);
  } catch (error) {
    console.error(`Error getting item ${key} from localStorage`, error);
    return undefined;
  }
};

const remove = (key) => {
  try {
    getStorage().removeItem(key);
  } catch (error) {
    console.error(`Error removing item ${key} from localStorage`, error);
  }
};

const setRaw = (key, value, storageType = "localStorage") => {
  try {
    getStorage(storageType).setItem(key, value);
    return { ok: true, error: null, storageType };
  } catch (error) {
    console.error(`Error setting raw item ${key} in ${storageType}`, error);
    return { ok: false, error, storageType };
  }
};

const getRaw = (key, storageType = "localStorage") => {
  try {
    return {
      ok: true,
      value: getStorage(storageType).getItem(key),
      error: null,
      storageType,
    };
  } catch (error) {
    console.error(`Error getting raw item ${key} from ${storageType}`, error);
    return { ok: false, value: null, error, storageType };
  }
};

const removeRaw = (key, storageType = "localStorage") => {
  try {
    getStorage(storageType).removeItem(key);
    return { ok: true, error: null, storageType };
  } catch (error) {
    console.error(`Error removing raw item ${key} from ${storageType}`, error);
    return { ok: false, error, storageType };
  }
};

const localStorageService = {
  set,
  get,
  remove,
  setRaw,
  getRaw,
  removeRaw,
};

export default localStorageService;
